import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "timetable-module"
};
var _hoisted_2 = {
  key: 0,
  class: "time-table"
};
var _hoisted_3 = {
  class: "row head"
};
var _hoisted_4 = {
  class: "row-head cell"
};
var _hoisted_5 = {
  key: 1,
  class: "empty-module"
};
import { getAppAlias, getTimeTableDetail, getTimeTableDefaultShowClass } from '@/api/home';
import { getStore } from '@/util/store';
import { ref, onMounted } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var emptyImg = require('./timetable-empty.svg');
    var dataMatrix = ref([]);
    var classTableInfo = ref(null);
    var token = ref(getStore({
      name: 'access_token'
    }));
    var colorMap = {
      '366EF4': ['语文', '政治', '地理', '信息技术', '劳动技术'],
      '14C24E': ['数学', '生物', '自然', '心理健康'],
      FFA63A: ['茶语', '物理', '化学', '通用技术', '科学'],
      FF7434: ['英语'],
      FF4B03: ['体育与健康'],
      FF1313: ['道德与法治', '历史'],
      FF3A8C: ['音乐', '日语'],
      '3AC1FF': ['美术', '俄语'],
      '001AFF': ['其他']
    };
    var columeMap = ref({
      1: [],
      2: [],
      3: [],
      4: [],
      5: [],
      6: [],
      7: []
    });
    var weeks = ref([{
      label: '周一',
      value: 1
    }, {
      label: '周二',
      value: 2
    }, {
      label: '周三',
      value: 3
    }, {
      label: '周四',
      value: 4
    }, {
      label: '周五',
      value: 5
    }, {
      label: '周六',
      value: 6
    }, {
      label: '周日',
      value: 7
    }]);
    var getShowSetting = function getShowSetting() {
      getTimeTableDefaultShowClass().then(function (res) {
        var _res$data$data;
        if (res.data.code === 0 && (_res$data$data = res.data.data) !== null && _res$data$data !== void 0 && _res$data$data.classId && res.data.data.classId !== '0') {
          classTableInfo.value = res.data.data;
          getDetails();
        } else {
          classTableInfo.value = null;
        }
      }).catch(function (err) {
        console.log(err);
      });
    };
    var getDetails = function getDetails() {
      var _classTableInfo$value = classTableInfo.value,
        schoolId = _classTableInfo$value.schoolId,
        gradeId = _classTableInfo$value.gradeId,
        semesterId = _classTableInfo$value.semesterId,
        classId = _classTableInfo$value.classId,
        yearWeekOfYear = _classTableInfo$value.yearWeekOfYear;
      columeMap.value = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: []
      };
      weeks.value = [{
        label: '周一',
        value: 1
      }, {
        label: '周二',
        value: 2
      }, {
        label: '周三',
        value: 3
      }, {
        label: '周四',
        value: 4
      }, {
        label: '周五',
        value: 5
      }, {
        label: '周六',
        value: 6
      }, {
        label: '周日',
        value: 7
      }];
      getTimeTableDetail({
        schoolId: schoolId,
        gradeId: gradeId,
        semesterId: semesterId,
        classId: classId,
        yearWeekOfYear: yearWeekOfYear
      }).then(function (res) {
        var data = res.data.data;
        var days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
        weeks.value = data.weekDays.map(function (ele, idx) {
          return {
            label: ele + days[idx],
            value: idx + 1,
            day: ele
          };
        });
        weeks.value = weeks.value.slice(0, data.col || 7);
        dataMatrix.value = data.matrix;
        dataMatrix.value.forEach(function (ele) {
          ele.columns.forEach(function (cell, idx) {
            var _cell$cell;
            var currentWeek = columeMap.value[cell.week];
            console.log(currentWeek);
            if (currentWeek.length === 0 || ((_cell$cell = cell.cell) === null || _cell$cell === void 0 ? void 0 : _cell$cell.course.courseName) !== currentWeek.slice(-1)[0].name) {
              var _cell$cell2, _cell$cell3, _cell$cell4;
              currentWeek.push({
                name: ((_cell$cell2 = cell.cell) === null || _cell$cell2 === void 0 ? void 0 : _cell$cell2.course.courseName) || '',
                start: (_cell$cell3 = cell.cell) === null || _cell$cell3 === void 0 ? void 0 : _cell$cell3.lesson,
                end: (_cell$cell4 = cell.cell) === null || _cell$cell4 === void 0 ? void 0 : _cell$cell4.lesson
              });
            } else {
              var _cell$cell5;
              currentWeek[currentWeek.length - 1].end = (_cell$cell5 = cell.cell) === null || _cell$cell5 === void 0 ? void 0 : _cell$cell5.lesson;
            }
          });
        });
        console.log(columeMap.value);
      });
    };
    var getColor = function getColor(cell) {
      var _cell$course;
      if (!cell) return '';
      var type = ((_cell$course = cell.course) === null || _cell$course === void 0 ? void 0 : _cell$course.courseName) || '';
      if (!type) return '';
      var res = '';
      var color = Object.keys(colorMap);
      for (var i = 0; i < color.length; i++) {
        if (colorMap[color[i]].includes(type)) {
          res = "background-color: #".concat(color[i], "20; border: 1px solid #").concat(color[i], "; color: #").concat(color[i], ";");
          break;
        }
      }
      if (!res) {
        res = "background-color: #001AFF20; border: 1px solid #001AFF; color: #001AFF;";
      }
      var showList = columeMap.value[cell.week].map(function (ele) {
        return {
          keys: (ele === null || ele === void 0 ? void 0 : ele.start) || 0,
          len: ((ele === null || ele === void 0 ? void 0 : ele.end) || 0) - ((ele === null || ele === void 0 ? void 0 : ele.start) || 0) + 1
        };
      });
      var current = showList.find(function (ele) {
        return ele.keys === cell.lesson;
      });
      if (current) {
        res += "height: ".concat(current.len * 60 + current.len - 1, "px; line-height: ").concat(current.len * 60 + current.len - 1, "px;");
      }
      return res;
    };
    var isCellShow = function isCellShow(cell) {
      if (!cell) return false;
      var showList = columeMap.value[cell.week].map(function (ele) {
        return (ele === null || ele === void 0 ? void 0 : ele.start) || 0;
      });
      return showList.includes(cell.lesson);
    };
    var isToday = function isToday(week) {
      var today = new Date();
      var month = today.getMonth() + 1;
      var day = today.getDate();
      return week.day && week.day === "".concat(month, "/").concat(day);
    };
    var parseLesson = function parseLesson(lesson) {
      var word = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];
      return "\u7B2C".concat(word[lesson], "\u8282");
    };
    var jumpToApp = function jumpToApp() {
      getAppAlias('stuTimeTable').then(function (res) {
        if (res.data.code === 0) {
          var url = "".concat(window.location.protocol).concat(res.data.data.app.url, "?token=").concat(token.value);
          window.open(url);
        } else {
          MessagePlugin.warning('抱歉，您暂无权限访问');
        }
      });
    };
    onMounted(function () {
      getShowSetting();
    });
    return function (_ctx, _cache) {
      var _component_empty = _resolveComponent("empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [classTableInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "row-head cell"
      }, null, -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weeks.value, function (head, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['row-item', 'cell', {
            today: isToday(head)
          }])
        }, [_createElementVNode("span", null, _toDisplayString(head.label), 1)], 2);
      }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataMatrix.value, function (lesson, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "row"
        }, [_createElementVNode("div", _hoisted_4, _toDisplayString(parseLesson(lesson.lesson)), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lesson.columns, function (week) {
          var _week$cell;
          return _openBlock(), _createElementBlock("div", {
            key: week.week,
            class: "row-item cell"
          }, [_withDirectives(_createElementVNode("span", {
            class: "course",
            style: _normalizeStyle(getColor(week.cell))
          }, _toDisplayString((_week$cell = week.cell) === null || _week$cell === void 0 || (_week$cell = _week$cell.course) === null || _week$cell === void 0 ? void 0 : _week$cell.courseName), 5), [[_vShow, isCellShow(week.cell)]])]);
        }), 128))]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_empty, {
        icon: _unref(emptyImg),
        fullHeight: true,
        onClick: jumpToApp
      }, {
        description: _withCtx(function () {
          return _toConsumableArray(_cache[1] || (_cache[1] = [_createElementVNode("span", {
            class: "des-words"
          }, [_createTextVNode("暂未设置课表信息，点击"), _createElementVNode("span", {
            class: "text-primary"
          }, "此处"), _createTextVNode("前往课表应用设置")], -1)]));
        }),
        _: 1
      }, 8, ["icon"])]))]);
    };
  }
};